<template>
  <v-dialog
    v-model="dialog"
    max-width="500"
    persistent
  >
    <v-card>
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
        data-cy="titulo_modal"
      >
        Informar devolução
      </v-card-title>

      <div>
        <v-card-text
          v-if="respostaSuccess"
          class="pt-3"
        >
          <p>
            A confirmação de devolução foi enviada com sucesso.
            Aguarde o vendedor confirmar o recebimento do produto
            para que seu reembolso seja realizado.
          </p>
        </v-card-text>

        <v-card-text
          v-else
          class="pt-3"
        >
          <p>
            Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.
          </p>
        </v-card-text>
      </div>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          text
          href="/minhas-compras"
          data-cy="fechar_sucesso_reembolso"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'ModalDevolucaoProduto',

  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    respostaSuccess: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
